var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBehance = function SvgBehance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 24.325V6h8.505c2.731 0 4.946 2.206 4.946 4.927 0 1.729-.534 2.8-2.491 3.899 2.342 1.063 2.992 2.536 2.992 4.59 0 2.78-2.479 4.909-5.27 4.909zM5.599 9.033v4.407H9.81s2.047 0 2.047-2.203c0-2.204-2.047-2.204-2.047-2.204zm0 12.188v-4.758h4.518c.73 0 2.259.375 2.259 2.625 0 1.67-1.506 2.118-2.26 2.133zM23.647 11.049c-2.589 0-6.424 1.852-6.424 6.774 0 2.997 1.647 6.844 6.589 6.844 3.953 0 5.772-2.891 6.188-4.336h-3.718c-.188.656-.918 1.382-2.47 1.382-2.26 0-3.06-1.922-3.177-2.883H30v-1.007c0-4.922-3.765-6.774-6.353-6.774m0 2.813c-2.109 0-2.887 1.734-3.012 2.601h5.647c0-.867-.527-2.601-2.635-2.601",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.152 7.041v2.274h8.871V7.04z"
  })));
};
export default SvgBehance;